
/*
NOTES
- Removed: `.side-panel .panel-container.is-visible` seems redundant.
- Removed `.main-panel-container` class.
  - It triggers saving in older versions of the mobile app? Still need it?

TODO
- Perhaps don't show 'Saved' button since user can never save on this panel?
- Don't show privacy if isPrivacyFetched false? Still show other sections?
- Fork or rename old components
- Port over other methods
**/

import { Component, Getter, namespace, Vue } from 'bits/vue'
import SurfacePanelShareModalPrivacyInfo from 'vuecomponents/surface_panel_share_modal_privacy_info.vue'
import SurfacePanelShareSectionExport from 'vuecomponents/surface_panel_share_section_export.vue'
import SurfacePanelShareSectionMainLeave from 'vuecomponents/surface_panel_share_section_main_leave.vue'
import SurfacePanelShareSectionMainMembers from 'vuecomponents/surface_panel_share_section_main_members.vue'
import SurfacePanelShareSectionMainPrivacy from 'vuecomponents/surface_panel_share_section_main_privacy.vue'
import SurfacePanelShareSectionShareMethods from 'vuecomponents/surface_panel_share_section_share_methods.vue'

@Component({
  components: {
    SurfacePanelShareSectionMainPrivacy,
    SurfacePanelShareSectionMainMembers,
    SurfacePanelShareModalPrivacyInfo,
    SurfacePanelShareSectionShareMethods,
    SurfacePanelShareSectionExport,
    SurfacePanelShareSectionMainLeave,
  },
})
class ShareMainPanel extends Vue {
  showPrivacyModal = false
  @Getter canIAdminister!: boolean
  @Getter amICollaborator!: boolean
  @namespace('wallAccessSettings').Getter isWallAccessSettingsFetched
  @namespace('share').Action confirmResetSharePanel
}

export default ShareMainPanel
